<template>
    <div>
        <div
            class="flex justify-between items-center p-4 bg-white border-b border-gray-200"
        >
            <AppLogo :appName="appName" />
            <div>
                <Icon
                    name="list"
                    @click="isOpen = !isOpen"
                    class="w-6 h-6 text-gray-500 cursor-pointer"
                />
            </div>
        </div>
        <Drawer
            :raw="true"
            :show="isOpen"
            side="left"
            :showCloseButton="false"
            @close="isOpen = false"
        >
            <div class="p-4">
                <AppLogo :appName="appName" />
            </div>
            <ul class="space-y-2 px-2">
                <div
                    v-if="integrationsRequiringAttention"
                    class="p-2 text-sm"
                >
                    <Alert
                        type="danger"
                        title="Attention!"
                    >
                        You have at least one integration that needs your
                        attention.
                    </Alert>
                </div>

                <div class="space-y-0.5">
                    <SidebarItem
                        iconName="home"
                        :href="RoutePathAppEnum.Root"
                        :active="currentRoute == RoutePathAppEnum.Root"
                    >
                        Dashboard
                    </SidebarItem>
                    <SidebarItem
                        iconName="clock"
                        :href="RoutePathAppEnum.Availabilities"
                        :active="
                            currentRoute.startsWith(
                                RoutePathAppEnum.Availabilities,
                            )
                        "
                    >
                        Availability
                    </SidebarItem>
                    <SidebarItem
                        iconName="calendar"
                        :href="RoutePathAppEnum.Meetings"
                        :active="
                            currentRoute.startsWith(RoutePathAppEnum.Meetings)
                        "
                    >
                        Meetings
                    </SidebarItem>
                    <SidebarItem
                        iconName="box"
                        :href="RoutePathAppEnum.Services"
                        :active="
                            currentRoute.startsWith(RoutePathAppEnum.Services)
                        "
                    >
                        Services
                    </SidebarItem>
                    <SidebarItem
                        iconName="plug"
                        :href="RoutePathAppEnum.Integrations"
                        :active="
                            currentRoute.startsWith(
                                RoutePathAppEnum.Integrations,
                            )
                        "
                    >
                        Integrations
                    </SidebarItem>
                    <SidebarItem
                        iconName="bolt"
                        :href="RoutePathAppEnum.Automations"
                        :active="
                            currentRoute.startsWith(
                                RoutePathAppEnum.Automations,
                            )
                        "
                    >
                        Automations
                    </SidebarItem>
                </div>

                <SidebarDivider />

                <div class="space-y-0.5">
                    <SidebarItem
                        v-if="authCompanyUser.isAdminOrOwner()"
                        iconName="company"
                        :href="RoutePathAppEnum.Company"
                        :active="
                            currentRoute.startsWith(RoutePathAppEnum.Company)
                        "
                    >
                        Company
                    </SidebarItem>
                    <SidebarItem
                        iconName="user"
                        :href="RoutePathAppEnum.MyProfile"
                        :active="
                            currentRoute.startsWith(RoutePathAppEnum.MyProfile)
                        "
                    >
                        My Profile
                    </SidebarItem>
                    <SidebarItem
                        iconName="logout"
                        as="button"
                        class="w-full"
                        @click="logoutApiFormRef?.submit()"
                    >
                        Logout
                    </SidebarItem>
                    <ApiForm
                        :url="RoutePathAppEnum.Auth_Logout"
                        method="POST"
                        ref="logoutApiFormRef"
                    />
                </div>
            </ul>
        </Drawer>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import SidebarItem from '@/Shared/Layout/App/Sidebar/SidebarItem.vue'
    import SidebarDivider from '@/Shared/Layout/App/Sidebar/SidebarDivider.vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import Alert from '@/Shared/Component/Alert.vue'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import User from '@/App/User/Entity/User'

    interface AppMobileTopbarProps {
        appName: string
        currentRoute: string
        authUser: User
        authCompanyUser: CompanyUser
        integrationsRequiringAttention: number
    }

    const props = defineProps<AppMobileTopbarProps>()
    const isOpen = ref(false)
    const logoutApiFormRef = ref<ApiFormRefType>(null)
</script>
